import React, { useEffect, useRef } from 'react'
import { useGLTF, useAnimations, useTexture } from '@react-three/drei'
import { useThree } from '@react-three/fiber'
import useGame from '../stores/useGame'
import * as THREE from 'three'

export function CGTModule(props) {

    const group = useRef()
    const { nodes, materials, animations } = useGLTF('/CGT_Module.glb')
    const { actions } = useAnimations(animations, group)
    const thruster = useGame((state) => state.thruster)

    const hetAO = useTexture('./textures/CGT_Thruster_AO.webp')
      hetAO.flipY = false
      materials.CG_Thruster.aoMap = hetAO
      materials.CG_Thruster.aoMapIntensity = 1

    const state = useThree()
    const phase = useGame((state) => state.phase)

    const highlight = useGame((state) => state.highlight)

    const highlightMaterial = new THREE.MeshStandardMaterial({
      color: 'red',
      emissive: 'red',
      emissiveIntensity: 0.25,
    })

    useEffect(() => {
    if(state.size.width > 950)

    {
        if (highlight === 'h_ps') { state.scene.traverse(obj => { if(obj.name.includes('S_PS')) { obj.material = highlightMaterial } }) }

        if (highlight === 'h_fd') { state.scene.traverse(obj => { if(obj.name.includes('S_FD')) { obj.material = highlightMaterial } }) }

        if (highlight === 'h_pr') { state.scene.traverse(obj => { if(obj.name.includes('S_PR')) { obj.material = highlightMaterial } }) }
        
        if (highlight === 'null') 
            {
            state.scene.traverse(obj => {

                if(obj.name.includes('CGT_S_PS') | obj.name.includes('CGT_S_FD') | obj.name.includes('CGT_S_PR'))
                {
                    obj.material = materials.CG_Thruster
                }
            })
            }
    }
    },[highlight])

    useEffect(() => {

        if (phase === 'zoomed') 
            {
                actions['CGT_Animation'].loop = false
                actions['CGT_Animation'].clampWhenFinished = true
                actions['CGT_Animation'].timeScale = 1
                actions['CGT_Animation'].repetitions = 0
                actions['CGT_Animation'].paused = false
                actions['CGT_Animation'].play()
            }
    
        if (phase != 'zoomed') 
            {
                actions['CGT_Animation'].loop = false
                actions['CGT_Animation'].clampWhenFinished = true
                actions['CGT_Animation'].timeScale = -1
                actions['CGT_Animation'].repetitions = 0
                actions['CGT_Animation'].paused = false
                actions['CGT_Animation'].play()
            }
        }, [phase, actions])

  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <group name="CGT_Animator">
          <group name="CGT_POI_C_CP" position={[0.491, -0.088, 0.041]} />
          <group name="CGT_POI_C_FD1" position={[0.508, -0.079, -0.086]} />
          <group name="CGT_POI_C_FP" position={[0.491, -0.047, 0.059]} />
          <group name="CGT_POI_C_IV1" position={[0.484, -0.091, -0.031]} />
          <group name="CGT_POI_C_NZ" position={[0.52, 0.013, 0]} />
          <group name="CGT_POI_C_PR1" position={[0.491, -0.103, -0.059]} />
          <group name="CGT_POI_C_PR2" position={[0.491, -0.005, 0.073]} />
          <group name="CGT_POI_C_SF1" position={[0.478, -0.067, -0.06]} />
          <group name="CGT_POI_C_SS" position={[0.488, 0.058, 0.042]} />
          <group name="CGT_POI_S_FD" position={[0.485, 0.05, 0.024]} />
          <group name="CGT_POI_S_PR" position={[0.479, -0.044, 0.059]} />
          <group name="CGT_POI_S_PS" position={[0.452, 0, -0.059]} />

          <group name="CGT_POS_C_CP" position={[0.451, -0.088, 0.041]} />
          <group name="CGT_POS_C_FD1" position={[0.46, -0.067, -0.094]} />
          <group name="CGT_POS_C_FP" position={[0.456, -0.05, 0.039]} />
          <group name="CGT_POS_C_IV1" position={[0.451, -0.071, -0.02]} />
          <group name="CGT_POS_C_NZ" position={[0.57, 0.014, -0.031]} />
          <group name="CGT_POS_C_PR1" position={[0.454, -0.122, -0.059]} />
          <group name="CGT_POS_C_PR2" position={[0.457, -0.006, 0.097]} />
          <group name="CGT_POS_C_SF1" position={[0.448, -0.07, -0.041]} />
          <group name="CGT_POS_C_SS" position={[0.442, 0.057, 0.043]} />
          <group name="CGT_POS_S_FD" position={[0.412, 0.028, 0.033]} />
          <group name="CGT_POS_S_PR" position={[0.406, -0.055, 0.045]} />
          <group name="CGT_POS_S_PS" position={[0.405, -0.07, -0.035]} />

          <group name="CGT_TAR_C_CP" position={[0.491, -0.088, 0.041]} />
          <group name="CGT_TAR_C_FD1" position={[0.508, -0.087, -0.085]} />
          <group name="CGT_TAR_C_FP" position={[0.491, -0.047, 0.059]} />
          <group name="CGT_TAR_C_IV1" position={[0.484, -0.087, -0.032]} />
          <group name="CGT_TAR_C_NZ" position={[0.545, 0.002, 0]} />
          <group name="CGT_TAR_C_PR1" position={[0.491, -0.103, -0.059]} />
          <group name="CGT_TAR_C_PR2" position={[0.491, -0.005, 0.073]} />
          <group name="CGT_TAR_C_SF1" position={[0.478, -0.067, -0.06]} />
          <group name="CGT_TAR_C_SS" position={[0.488, 0.045, 0.042]} />
          <group name="CGT_TAR_S_FD" position={[0.485, 0.025, 0.024]} />
          <group name="CGT_TAR_S_PR" position={[0.489, -0.047, 0.054]} />
          <group name="CGT_TAR_S_PS" position={[0.477, -0.05, -0.059]} />

          {thruster === 'CGT' && <> 
           <mesh
            name="CGT_C_Back_Plate"
            castShadow
            receiveShadow
            geometry={nodes.CGT_C_Back_Plate.geometry}
            material={materials.CG_Thruster}
            position={[0.518, 0, 0]}
          />
          <mesh
            name="CGT_C_Bolts"
            castShadow
            receiveShadow
            geometry={nodes.CGT_C_Bolts.geometry}
            material={materials.CG_Thruster}
          />
          <mesh
            name="CGT_C_PowerCable"
            castShadow
            receiveShadow
            geometry={nodes.CGT_C_PowerCable.geometry}
            material={materials.CG_Thruster}
            position={[0.499, -0.028, 0.088]}
            rotation={[-Math.PI, 0, 0]}
            scale={0.688}
          />
          <mesh
            name="CGT_S_FD_C_Box"
            castShadow
            receiveShadow
            geometry={nodes.CGT_S_FD_C_Box.geometry}
            material={materials.CG_Thruster}
            position={[0.497, 0.057, 0.039]}
            rotation={[-Math.PI / 2, 0, 0]}
          />
          <mesh
            name="CGT_S_FD_C_NZ"
            castShadow
            receiveShadow
            geometry={nodes.CGT_S_FD_C_NZ.geometry}
            material={materials.CG_Thruster}
            position={[0.557, 0, 0]}
            rotation={[0, 0, Math.PI / 2]}
          />
          <mesh
            name="CGT_S_FD_C_SS_Red"
            castShadow
            receiveShadow
            geometry={nodes.CGT_S_FD_C_SS_Red.geometry}
            material={materials.CG_Thruster}
          />
          <mesh
            name="CGT_S_FD_C_SS_White"
            castShadow
            receiveShadow
            geometry={nodes.CGT_S_FD_C_SS_White.geometry}
            material={materials.CG_Thruster}
          />
          <mesh
            name="CGT_S_FD_C_ThrustPlate"
            castShadow
            receiveShadow
            geometry={nodes.CGT_S_FD_C_ThrustPlate.geometry}
            material={materials.CG_Thruster}
            position={[0.508, 0, 0]}
          />
          <mesh
            name="CGT_S_PR_C_CP"
            castShadow
            receiveShadow
            geometry={nodes.CGT_S_PR_C_CP.geometry}
            material={materials.CG_Thruster}
            position={[0.498, -0.087, 0.041]}
          />
          <mesh
            name="CGT_S_PR_C_FP"
            castShadow
            receiveShadow
            geometry={nodes.CGT_S_PR_C_FP.geometry}
            material={materials.CG_Thruster}
            position={[0.498, -0.046, 0.059]}
            rotation={[-Math.PI / 2, 0, 0]}
          />
          <mesh
            name="CGT_S_PR_C_Join1"
            castShadow
            receiveShadow
            geometry={nodes.CGT_S_PR_C_Join1.geometry}
            material={materials.CG_Thruster}
            position={[0.491, -0.087, 0.059]}
          />
          <mesh
            name="CGT_S_PR_C_Join2"
            castShadow
            receiveShadow
            geometry={nodes.CGT_S_PR_C_Join2.geometry}
            material={materials.CG_Thruster}
            position={[0.491, -0.005, 0.059]}
          />
          <mesh
            name="CGT_S_PR_C_Pipes"
            castShadow
            receiveShadow
            geometry={nodes.CGT_S_PR_C_Pipes.geometry}
            material={materials.CG_Thruster}
          />
          <mesh
            name="CGT_S_PR_C_PR2"
            castShadow
            receiveShadow
            geometry={nodes.CGT_S_PR_C_PR2.geometry}
            material={materials.CG_Thruster}
            position={[0.498, -0.101, 0.059]}
          />
          <mesh
            name="CGT_S_PS_C_FD1"
            castShadow
            receiveShadow
            geometry={nodes.CGT_S_PS_C_FD1.geometry}
            material={materials.CG_Thruster}
            position={[0.516, -0.087, -0.085]}
          />
          <mesh
            name="CGT_S_PS_C_IV1"
            castShadow
            receiveShadow
            geometry={nodes.CGT_S_PS_C_IV1.geometry}
            material={materials.CG_Thruster}
            position={[0.496, -0.087, -0.032]}
          />
          <mesh
            name="CGT_S_PS_C_Join"
            castShadow
            receiveShadow
            geometry={nodes.CGT_S_PS_C_Join.geometry}
            material={materials.CG_Thruster}
            position={[0.491, -0.087, -0.059]}
          />
          <mesh
            name="CGT_S_PS_C_Pipes"
            castShadow
            receiveShadow
            geometry={nodes.CGT_S_PS_C_Pipes.geometry}
            material={materials.CG_Thruster}
          />
          <mesh
            name="CGT_S_PS_C_PR1"
            castShadow
            receiveShadow
            geometry={nodes.CGT_S_PS_C_PR1.geometry}
            material={materials.CG_Thruster}
            position={[0.498, -0.101, -0.059]}
          />
          <mesh
            name="CGT_S_PS_C_SF1"
            castShadow
            receiveShadow
            geometry={nodes.CGT_S_PS_C_SF1.geometry}
            material={materials.CG_Thruster}
            position={[0.484, -0.066, -0.06]}
            rotation={[Math.PI / 2, 0, 0]}
          />
          <mesh
            name="CGT_S_PS_C_Tank"
            castShadow
            receiveShadow
            geometry={nodes.CGT_S_PS_C_Tank.geometry}
            material={materials.CG_Thruster}
            position={[0.48, 0.026, -0.059]}
          /></>}
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/CGT_Module.glb')
